import React from "react"

import { CommentsModal, DataModal } from "./TableModalBase"

export default function DataAndCommentExportModals({
  showDataModal = false,
  showCommentsModal = false,
  onHideDataModal = () => {},
  onHideCommentsModal = () => {},
  actions = [],
  perGraphZoom,
  commonDataVars = [],
  plotFactory,
  exportBaseName,
  op = {},
  viewerState = {},
}) {
  const {
    intl, // LTPM specific variable
    selected_timezone, // LL specific variable
  } = viewerState

  const exportName = plotFactory.getExportCSVName ? plotFactory.getExportCSVName(exportBaseName) : null

  let dataTableData, exportDataThunk, commentTableData, commentDataThunk
  if (showDataModal) {
    dataTableData = plotFactory.getDataForRows
      ? plotFactory.getDataForRows(...commonDataVars, viewerState, perGraphZoom, selected_timezone, intl)
      : null
    exportDataThunk =
      plotFactory.makeExportCSV && dataTableData
        ? plotFactory.makeExportCSV.bind(plotFactory, dataTableData)
        : null
  }

  if (showCommentsModal) {
    commentTableData = plotFactory.getCommentDataForRows
      ? plotFactory.getCommentDataForRows(
          actions,
          ...commonDataVars,
          selected_timezone,
          intl,
          op.special === "multi",
        )
      : null
    commentDataThunk =
      plotFactory.makeExportCSV && commentTableData
        ? plotFactory.makeExportCSV.bind(plotFactory, commentTableData)
        : null
  }

  return (
    <>
      {showDataModal && (
        <DataModal
          intl={intl}
          show={showDataModal}
          onHide={() => onHideDataModal()}
          graphKey={op}
          table_data={dataTableData}
          exportDataThunk={exportDataThunk}
          filename={exportName}
          exportBaseName={exportBaseName}
        />
      )}
      {showCommentsModal && (
        <CommentsModal
          intl={intl}
          show={showCommentsModal}
          onHide={() => onHideCommentsModal()}
          table_data={commentTableData}
          exportDataThunk={commentDataThunk}
          filename={`${exportBaseName}-Comments.csv`}
          exportBaseName={exportBaseName}
        />
      )}
    </>
  )
}
